module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"goBack":"Powrót","goToPanel":"Przejdź do panelu"}}')
  delete Component.options._Ctor
}
